export const isUndefinedOrEmptyString = (argument?: string) =>
  argument === undefined || argument.trim() === '';
